export class Image {
    groupname: string;
    description: string;
    isdefault: boolean;
    filename: string;
    url: string | null;
}
